import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './styles/globals.css'
import { EntraAuthProvider } from './auth/EntraAuthProvider'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <EntraAuthProvider>
      <App />
    </EntraAuthProvider>
  </React.StrictMode>,
)
